document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    const form = document.querySelector('.zwssgr-setting-form');

     if (!form) {
        // console.error('Form with class .zwssgr-setting-form not found.');
        return; // Stop running the rest of the code if form is missing
    }

    // TOGGLE VISIBILITY FOR SCHEMA SETTINGS
    const schemaToggle = document.getElementById("zwssgr-schema_enabled");
    const conditionalElements = document.querySelectorAll(
        ".zwssgr-schema-conditional, #zwssgr-custom-widget-selector"
    );

    const updateSchemaVisibility = () => {
        const show = schemaToggle.checked;

        schemaToggle.value = show ? 1 : 0;

        conditionalElements.forEach(el => {
            el.classList.toggle("visible", show);
            el.classList.toggle("hidden", !show);
        });
    };

    if (schemaToggle) {
        updateSchemaVisibility();
        schemaToggle.addEventListener("change", updateSchemaVisibility);
    }

    // Condition logic for showing/hiding page selectors based on schema type
    function updatePageSelectors() {
        var aggChecked = document.querySelector('input[name="custom_schema_types[]"][value="AggregateRating"]').checked;
        var orgChecked = document.querySelector('input[name="custom_schema_types[]"][value="Organization"]').checked;
        var localBusinessChecked = document.querySelector('input[name="custom_schema_types[]"][value="LocalBusiness"]').checked;

        var aggSelector = document.getElementById("zwssgr-aggregate-rating-page-selector");
        var orgSelector = document.getElementById("zwssgr-organization-page-selector");
        
        if (aggSelector) {
            aggSelector.style.display = aggChecked ? "block" : "none";
        }
        if (orgSelector) {
            // Organization selector should show when Organization is checked
            orgSelector.style.display = orgChecked ? "block" : "none";
        }
        // LocalBusiness doesn't need a page selector as it works on home page
    }

    // Attach event listeners to schema type checkboxes
    var schemaTypeCheckboxes = document.querySelectorAll('input[name="custom_schema_types[]"]');
    schemaTypeCheckboxes.forEach(function (cb) {
        cb.addEventListener("change", updatePageSelectors);
    });

    // Run on page load
    updatePageSelectors();

    // Form validation for required page selectors
    var schemaForm = document.querySelector('.zwssgr-setting-form');
    // console.log('Schema form found:', schemaForm);
    
    if (schemaForm) {
        schemaForm.addEventListener('submit', function(e) {
            // console.log('Form submit event triggered');
            
            var messageArea = document.getElementById('zwssgr-message-area');
            var schemaEnabled = document.getElementById('zwssgr-schema_enabled');
            var aggChecked = document.querySelector('input[name="custom_schema_types[]"][value="AggregateRating"]').checked;
            var orgChecked = document.querySelector('input[name="custom_schema_types[]"][value="Organization"]').checked;
            var localBusinessChecked = document.querySelector('input[name="custom_schema_types[]"][value="LocalBusiness"]').checked;
            
            var aggSelect = document.getElementById("zwssgr_aggregate_rating_pages");
            var orgSelect = document.getElementById("zwssgr_organization_pages");
            
            // console.log('Elements found:', {
            //     messageArea: messageArea,
            //     schemaEnabled: schemaEnabled,
            //     aggChecked: aggChecked,
            //     orgChecked: orgChecked,
            //     localBusinessChecked: localBusinessChecked,
            //     aggSelect: aggSelect,
            //     orgSelect: orgSelect
            // });
            
            // Clear previous error messages
            if (messageArea) {
                messageArea.innerHTML = '';
            }
            
            var hasError = false;
            
            // Check if schema is enabled but no schema types are selected
            if (schemaEnabled && schemaEnabled.checked && !aggChecked && !orgChecked && !localBusinessChecked) {
                hasError = true;
                // console.log('Error: No schema types selected');
                if (messageArea) {
                    const errorDiv = document.createElement('div');
                    errorDiv.className = 'notice notice-error is-dismissible';
                    errorDiv.innerHTML = '<p>Please select at least one schema type (AggregateRating, Organization, or LocalBusiness).</p>';
                    messageArea.appendChild(errorDiv);
                }
            }
            
            // Check if any schema type is selected but no pages are selected (except LocalBusiness which works on home page)
            if (schemaEnabled && schemaEnabled.checked && (aggChecked || orgChecked)) {
                var aggPagesSelected = aggSelect && aggSelect.selectedOptions.length > 0;
                var orgPagesSelected = orgSelect && orgSelect.selectedOptions.length > 0;

                if (!aggPagesSelected && !orgPagesSelected) {
                    hasError = true;
                    if (messageArea) {
                        const errorDiv = document.createElement('div');
                        errorDiv.className = 'notice notice-error is-dismissible';
                        errorDiv.innerHTML = '<p>Please select at least one page for schema output.</p>';
                        messageArea.appendChild(errorDiv);
                    }
                } else {
                    // If AggregateRating is checked but no page selected
                    if (aggChecked && !aggPagesSelected) {
                        hasError = true;
                        if (messageArea) {
                            const errorDiv = document.createElement('div');
                            errorDiv.className = 'notice notice-error is-dismissible';
                            errorDiv.innerHTML = '<p>Please select at least one page for AggregateRating schema.</p>';
                            messageArea.appendChild(errorDiv);
                        }
                    }
                    // If Organization is checked but no page selected
                    if (orgChecked && !orgPagesSelected) {
                        hasError = true;
                        if (messageArea) {
                            const errorDiv = document.createElement('div');
                            errorDiv.className = 'notice notice-error is-dismissible';
                            errorDiv.innerHTML = '<p>Please select at least one page for Organization schema.</p>';
                            messageArea.appendChild(errorDiv);
                        }
                    }
                }
            }
            
            // LocalBusiness doesn't require page selection as it works on home page
            // No validation needed for LocalBusiness

            // console.log('Validation result - hasError:', hasError);
            
            if (hasError) {
                e.preventDefault();
                return false;
            }
        });
    } else {
        // console.log('Schema form not found!');
    }

    // CUSTOM MULTI-SELECT LOGIC FOR AGGREGATE RATING PAGES
    const aggregateSelect = document.getElementById("zwssgr_aggregate_rating_pages");
    const aggregateSearchInput = document.getElementById("zwssgr-aggregate-rating-search-input");
    const aggregateTagContainer = document.getElementById("zwssgr-aggregate-rating-selected-tags");
    const aggregateDropdown = document.getElementById("zwssgr-aggregate-rating-dropdown");

    if (aggregateSelect && aggregateSearchInput && aggregateTagContainer && aggregateDropdown) {
        const aggregateOptions = Array.from(aggregateSelect.options);

        function renderAggregateTags() {
            aggregateTagContainer.innerHTML = "";
            aggregateOptions.forEach(opt => {
                if (opt.selected) {
                    const tag = document.createElement("div");
                    tag.className = "zwssgr-custom-selected-tag";
                    tag.textContent = opt.text;

                    const remove = document.createElement("span");
                    remove.className = "zwssgr-remove-tag";
                    remove.textContent = "×";
                    remove.onclick = () => {
                        opt.selected = false;
                        renderAggregateTags();
                        renderAggregateDropdown(aggregateSearchInput.value);
                    };

                    tag.appendChild(remove);
                    aggregateTagContainer.appendChild(tag);
                }
            });
        }

        function renderAggregateDropdown(filter = "") {
            aggregateDropdown.innerHTML = "";

            const filtered = aggregateOptions.filter(opt =>
                !opt.selected && opt.text.toLowerCase().includes(filter.toLowerCase())
            );

            if (!filtered.length) {
                aggregateDropdown.style.display = "none";
                return;
            }

            filtered.forEach(opt => {
                const li = document.createElement("li");
                li.textContent = opt.text;
                li.onclick = () => {
                    opt.selected = true;
                    renderAggregateTags();
                    aggregateSearchInput.value = "";
                    renderAggregateDropdown();
                };
                aggregateDropdown.appendChild(li);
            });

            aggregateDropdown.style.display = "block";
        }

        aggregateSearchInput.addEventListener("input", () => renderAggregateDropdown(aggregateSearchInput.value));
        aggregateSearchInput.addEventListener("focus", () => renderAggregateDropdown(aggregateSearchInput.value));
        
        // Update click outside handler to work with new structure
        document.addEventListener("click", e => {
            const aggregateContainer = document.getElementById("zwssgr-aggregate-rating-page-selector");
            if (aggregateContainer && !aggregateContainer.contains(e.target)) {
                aggregateDropdown.style.display = "none";
            }
        });

        renderAggregateTags();
    }

    // CUSTOM MULTI-SELECT LOGIC FOR ORGANIZATION PAGES
    const organizationSelect = document.getElementById("zwssgr_organization_pages");
    const organizationSearchInput = document.getElementById("zwssgr-organization-search-input");
    const organizationTagContainer = document.getElementById("zwssgr-organization-selected-tags");
    const organizationDropdown = document.getElementById("zwssgr-organization-dropdown");

    if (organizationSelect && organizationSearchInput && organizationTagContainer && organizationDropdown) {
        const organizationOptions = Array.from(organizationSelect.options);

        function renderOrganizationTags() {
            organizationTagContainer.innerHTML = "";
            organizationOptions.forEach(opt => {
                if (opt.selected) {
                    const tag = document.createElement("div");
                    tag.className = "zwssgr-custom-selected-tag";
                    tag.textContent = opt.text;

                    const remove = document.createElement("span");
                    remove.className = "zwssgr-remove-tag";
                    remove.textContent = "×";
                    remove.onclick = () => {
                        opt.selected = false;
                        renderOrganizationTags();
                        renderOrganizationDropdown(organizationSearchInput.value);
                    };

                    tag.appendChild(remove);
                    organizationTagContainer.appendChild(tag);
                }
            });
        }

        function renderOrganizationDropdown(filter = "") {
            organizationDropdown.innerHTML = "";

            const filtered = organizationOptions.filter(opt =>
                !opt.selected && opt.text.toLowerCase().includes(filter.toLowerCase())
            );

            if (!filtered.length) {
                organizationDropdown.style.display = "none";
                return;
            }

            filtered.forEach(opt => {
                const li = document.createElement("li");
                li.textContent = opt.text;
                li.onclick = () => {
                    opt.selected = true;
                    renderOrganizationTags();
                    organizationSearchInput.value = "";
                    renderOrganizationDropdown();
                };
                organizationDropdown.appendChild(li);
            });

            organizationDropdown.style.display = "block";
        }

        organizationSearchInput.addEventListener("input", () => renderOrganizationDropdown(organizationSearchInput.value));
        organizationSearchInput.addEventListener("focus", () => renderOrganizationDropdown(organizationSearchInput.value));
        
        // Update click outside handler to work with new structure
        document.addEventListener("click", e => {
            const organizationContainer = document.getElementById("zwssgr-organization-page-selector");
            if (organizationContainer && !organizationContainer.contains(e.target)) {
                organizationDropdown.style.display = "none";
            }
        });

        renderOrganizationTags();
    }
});
